import React, { Component } from 'react'
import { Col, Row } from '../../../../Shared/Grid'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import sortBy from 'lodash.sortby'
import { SHAPE_ROOM } from '../shapes'
import DetailsUpdater from '../DetailsUpdater'
import Icon from '../../../../Shared/Icon'
import SelectTracked from '../../../../Shared/FormTracked/SelectTracked'
import InputTracked from '../../../../Shared/FormTracked/InputTracked'
import { trackingEvent } from '../../../../../constants'
import activityTrackingService from '../../../../../services/activityTrackingService'

const eventValues = {
  field: {
    roomView: 'Room view',
    roomType: 'Room type',
    roomCategory: 'Room category',
  }
}

class RoomForm extends Component {

  state = {
    roomType: null,
    roomCategory: null,
    roomView: null,
    roomName: '',
    pmsCode: '',
    internalCode: '',
    optionsRoomType: [],
    optionsRoomCategory: [],
    optionsRoomView: [],
    details: [],
    internalCodeIsValid: true,
    detailsFormIsValid: true,
  }

  componentDidMount () {
    this.populateOptions()
    this.populateValues()
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (this.props.roomAttributes !== prevProps.roomAttributes) {
      this.populateOptions()
    }
    if (this.props.room !== prevProps.room) {
      this.populateValues()
    }
  }

  populateValues () {
    let roomType = null, roomCategory = null, roomView = null
    let roomName = '', pmsCode = '', internalCode = ''

    const nameAttribute = this.props.roomAttributes.roomName[Object.keys(this.props.roomAttributes.roomName)[0]]
    if (this.props.room) {
      this.props.room.attributes.forEach((attribute) => {
        if (this.props.roomAttributes.roomType.hasOwnProperty(attribute.id)) {
          roomType = attribute.id
        } else if (this.props.roomAttributes.roomCategory.hasOwnProperty(attribute.id)) {
          roomCategory = attribute.id
        } else if (this.props.roomAttributes.roomView.hasOwnProperty(attribute.id)) {
          roomView = attribute.id
        } else if (attribute.id === nameAttribute.id) {
          roomName = attribute.value
        }
      })
      this.props.room.codes.forEach((code) => {
        if (code.id === 'pms') {
          pmsCode = code.code
        } else if (code.id === 'internal') {
          internalCode = code.code
        }
      })
    }
    const details = this.props.room ? this.props.room.details : []
    this.setState({
      roomType,
      roomCategory,
      roomView,
      roomName,
      pmsCode,
      internalCode,
      details,
      internalCodeIsValid: internalCode.length < 1 || internalCode.indexOf(',') === -1
    })
  }

  populateOptions () {
    let optionsRoomType, optionsRoomCategory, optionsRoomView
    optionsRoomType = Object.keys(this.props.roomAttributes.roomType).map(e => this.props.roomAttributes.roomType[e])
    optionsRoomType = sortBy(optionsRoomType, ['value'])
    optionsRoomCategory = Object.keys(this.props.roomAttributes.roomCategory).map(e => this.props.roomAttributes.roomCategory[e])
    optionsRoomCategory = sortBy(optionsRoomCategory, ['value'])
    optionsRoomView = Object.keys(this.props.roomAttributes.roomView).map(e => this.props.roomAttributes.roomView[e])
    optionsRoomView = sortBy(optionsRoomView, ['value'])
    this.setState({
      optionsRoomType,
      optionsRoomCategory,
      optionsRoomView
    })
  }

  onDetailsChange = (details, detailsFormIsValid) => {
    if (detailsFormIsValid !== undefined) {
      this.setState({
        detailsFormIsValid: detailsFormIsValid
      }, () => {
        this.onChange('details', details)
      })
    } else {
      this.onChange('details', details)
    }
  }

  onChange = (key, value) => {
    let state = {}
    state[key] = value
    if (key === 'internalCode') {
      state.internalCodeIsValid = value.length < 1 || value.indexOf(',') === -1
    }
    this.setState(state, () => {
      const room = this.buildRoom()
      this.props.onChange(room, this.state.internalCodeIsValid && this.state.detailsFormIsValid)
    })
  }

  onClear = (key, eventFieldName) => {
    activityTrackingService.trackEvent(trackingEvent.editRoomInfoField, {
      field: eventFieldName,
    })
    let state = {}
    state[key] = null
    this.setState(state, () => {
      const room = this.buildRoom()
      this.props.onChange(room, this.state.internalCodeIsValid && this.state.detailsFormIsValid)
    })
  }

  buildRoom () {
    let obj = {}
    if (this.props.room) {
      obj = { ...this.props.room }
    }
    obj.attributes = []
    obj.codes = []
    obj.details = []
    if (this.state.roomType) {
      obj.attributes.push({ id: parseInt(this.state.roomType, 10) })
    }
    if (this.state.roomCategory) {
      obj.attributes.push({ id: parseInt(this.state.roomCategory, 10) })
    }
    if (this.state.roomView) {
      obj.attributes.push({ id: parseInt(this.state.roomView, 10) })
    }
    if (this.state.roomName !== '') {
      const nameAttribute = this.props.roomAttributes.roomName[
        Object.keys(this.props.roomAttributes.roomName)[0]
        ]
      if (!nameAttribute) {
        throw new Error('Could not find name attribute')
      }
      obj.attributes.push({ id: nameAttribute.id, value: this.state.roomName })
    }

    if (this.state.pmsCode) {
      obj.codes.push({ 'id': 'pms', 'code': this.state.pmsCode })
    }
    if (this.state.internalCode) {
      obj.codes.push({ 'id': 'internal', 'code': this.state.internalCode })
    }
    obj.details = this.state.details
    return obj
  }

  render () {
    const { t } = this.props
    const eventName = trackingEvent.editRoomInfoField
    return (
      <React.Fragment>
        <Row style={{ marginTop: '10px' }}>
          <Col xs={12} sm={6} lg={3}>
            <SelectTracked
              eventName={eventName}
              eventOpts={{ field: eventValues.field.roomCategory }}
              onChange={(e) => {this.onChange('roomCategory', e.target.value)}}
              options={this.state.optionsRoomCategory}
              optionValueKey={'id'}
              optionLabelKey={'value'}
              clearable={true}
              onClear={() => this.onClear('roomCategory', eventValues.field.roomCategory)}
              label={t('ROOM_CATEGORY')}
              selected={this.state.roomCategory}/>
          </Col>
          <Col xs={12} sm={6} lg={3}>
            <SelectTracked
              eventName={eventName}
              eventOpts={{ field: eventValues.field.roomType }}
              onChange={(e) => {this.onChange('roomType', e.target.value)}}
              options={this.state.optionsRoomType}
              optionValueKey={'id'}
              optionLabelKey={'value'}
              clearable={true}
              onClear={() => this.onClear('roomType', eventValues.field.roomType)}
              label={t('ROOM_TYPE')} selected={this.state.roomType}
            />
          </Col>
          <Col xs={12} sm={6} lg={3}>
            <SelectTracked
              eventName={eventName}
              eventOpts={{ field: eventValues.field.roomView }}
              onChange={(e) => {this.onChange('roomView', e.target.value)}}
              options={this.state.optionsRoomView}
              optionValueKey={'id'}
              optionLabelKey={'value'}
              clearable={true}
              onClear={() => this.onClear('roomView', eventValues.field.roomView)}
              label={t('ROOM_VIEW')}
              selected={this.state.roomView}/>
          </Col>
          <Col xs={12} sm={6} lg={3}>
            <InputTracked
              eventName={eventName}
              eventOpts={{ field: 'Room name' }}
              onChange={(e) => {this.onChange('roomName', e.target.value)}}
              label={t('ROOM_NAME')} value={this.state.roomName}/>
          </Col>
        </Row>
        <hr/>
        <Row>
          <Col xs={12} sm={6} lg={3}>
            <InputTracked
              eventName={eventName}
              eventOpts={{ field: 'Internal Code' }}
              valid={this.state.internalCodeIsValid}
              message={t('ROOM_INTERNAL_CODE_ERR_MSG')}
              onChange={(e) => {this.onChange('internalCode', e.target.value)}}
              label={t('INTERNAL_CODE')} value={this.state.internalCode}
              labelAppend={<Icon type={'how'} tooltip={t('TOOLTIP_ROOM_CODE_INTERNAL')} size={'extra-small'}/>}
            />
          </Col>
          <Col xs={12} sm={6} lg={3}>
            <InputTracked
              eventName={eventName}
              eventOpts={{ field: 'Hotelbeds Room Code' }}
              onChange={(e) => {this.onChange('pmsCode', e.target.value)}}
              label={t('HOTELBEDS_ROOM_CODE')}
              labelAppend={<Icon type={'how'} tooltip={t('TOOLTIP_CODE_PMS')} size={'extra-small'}/>}
              value={this.state.pmsCode}/>
          </Col>
        </Row>
        <hr/>
        <DetailsUpdater details={this.state.details}
                        onDetailsChange={this.onDetailsChange}/>
      </React.Fragment>
    )
  }
}

RoomForm.propTypes = {
  roomAttributes: PropTypes.object.isRequired,
  room: PropTypes.shape(SHAPE_ROOM),
  onChange: PropTypes.func.isRequired
}

export default withTranslation()(RoomForm)
